export const scrollElementIntoView = (
   elementId: string,
   options?: ScrollIntoViewOptions
) => {
   const element = document.getElementById(elementId)

   const scrollIntoViewOptions = options ?? {
      block: 'end',
      inline: 'nearest'
   }

   if (element) {
      element?.scrollIntoView(scrollIntoViewOptions)
   }
}

export const scrollElementIntoViewWithParentElement = (
   parentElement: HTMLElement,
   elementId: string,
   options?: ScrollIntoViewOptions
) => {
   const element = parentElement.querySelector(`#${elementId}`)

   const scrollIntoViewOptions = options ?? {
      block: 'end',
      inline: 'nearest'
   }

   if (element) {
      element?.scrollIntoView(scrollIntoViewOptions)
   }
}
